import Image from 'next/image';
import Link from 'next/link';
import LandingPageContainer from '../layout/landing-page-container';
import { prefix } from '../../lib/auth';

const LandingPageHeader = () => {
    return (
        <LandingPageContainer>
            <div className='flex items-center justify-between py-[15px]'>
                <Image src='/images/space-logo.svg' alt='logo' width={141} height={98} className='h-[29px] lg:h-[35px]' />
                <div className='flex items-center gap-[29px]'>
                    <Link href={`http://${prefix()}accounts.workpeg.com/login?peg=space&ep=/home`} className='text-white-50 text-[16px] pr-[36px] lg:pr-0'>Login</Link>
                    <Link href={`http://${prefix()}accounts.workpeg.com/register?peg=space&ep=/home`}  className='py-[6px] px-[24px] text-white-50 text-[16px] leading-[24px] border-[1px] border-[#50565D] rounded-[6px] hidden lg:block'>Sign up</Link>
                </div>
            </div>
        </LandingPageContainer>
    );
};

export default LandingPageHeader;